import { fetchWithSupabaseAuth } from "../lib/supabaseClient.js";
import {
  normalizeBillingPreferences,
  toBillingPreferencesPayload,
} from "../utils/billingPreferences.js";

export const BILLING_PREFERENCES_ENDPOINT = "/api/me/ui-preferences/billing";

export class BillingPreferencesApiError extends Error {
  constructor(message, { payload = null, status = null } = {}) {
    super(message);
    this.name = "BillingPreferencesApiError";
    this.payload = payload;
    this.status = Number.isFinite(status) ? Number(status) : null;
  }
}

function resolveErrorMessage(payload, fallback) {
  if (typeof payload?.detail === "string" && payload.detail.trim()) return payload.detail.trim();
  if (typeof payload?.message === "string" && payload.message.trim()) return payload.message.trim();
  return fallback;
}

async function parseResponse(response, fallbackMessage) {
  const payload = await response.json().catch(() => null);
  if (!response.ok) {
    throw new BillingPreferencesApiError(resolveErrorMessage(payload, fallbackMessage), {
      payload,
      status: response.status,
    });
  }
  return payload;
}

export async function fetchBillingPreferences({ fetchImpl, signal } = {}) {
  const response = await fetchWithSupabaseAuth(BILLING_PREFERENCES_ENDPOINT, {
    cache: "no-store",
    fetchImpl,
    method: "GET",
    signal,
  });
  const payload = await parseResponse(response, "Impossible de charger les préférences de facturation.");
  return payload === null ? null : normalizeBillingPreferences(payload);
}

export async function putBillingPreferences(preferences, {
  fetchImpl,
  keepalive = false,
  signal,
} = {}) {
  const response = await fetchWithSupabaseAuth(BILLING_PREFERENCES_ENDPOINT, {
    body: JSON.stringify(toBillingPreferencesPayload(preferences)),
    fetchImpl,
    headers: { "Content-Type": "application/json" },
    keepalive,
    method: "PUT",
    signal,
  });
  const payload = await parseResponse(response, "Impossible d’enregistrer les préférences de facturation.");
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    throw new BillingPreferencesApiError("La réponse des préférences de facturation est invalide.", {
      payload,
      status: response.status,
    });
  }
  return normalizeBillingPreferences(payload);
}
